const configureBuyerName = (buyerName?: string) => {
  if (buyerName && buyerName.length > 25) {
    const cutSection = buyerName.slice(0, 25);
    return `${cutSection}...`;
  }
  return buyerName;
};

const deaultBuyerElement = (buyerName?: string, buyerId?: number) => {
  return `${configureBuyerName(buyerName) || ''}- ${buyerId || ''}`;
};

const createBuyerElement = (
  buyerName?: string,
  buyerId?: number | undefined,
) => {
  if (buyerName && !buyerId) {
    return buyerName;
  }
  if (buyerId && !buyerName) {
    return buyerId;
  }
  return deaultBuyerElement(buyerName, buyerId);
};

export const buildName = (
  firstName: string | undefined,
  lastName: string | undefined,
  buyerName?: string | undefined,
  buyerId?: number | undefined,
): string => {
  if (buyerName || buyerId) {
    return createBuyerElement(buyerName, buyerId).toString();
  }
  return `${firstName || ''} ${lastName || ''}`;
};
